import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_057b2bbb";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_057b2bbb" };
/** script content **/
require("./time-picker.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findex057b2bbb%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Ftime-picker%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_057b2bbb"],
    ctorType: "component",
    outputPath: "components/index057b2bbb/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: { 'cube-cascade-picker': getComponent(require("../cascade-picker/index.mpx?isComponent&outputPath=components%2Findexb6a89be4%2Findex")) },
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
